var mediaViewType = Object.freeze({
   video: 'video',
   youtube: 'youtube',
   playlist: 'playlist',
   image: 'image'
});

export default mediaViewType;
